import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { InputV2 } from 'components';
const CssBox = ({ css, setCss }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={3} className={classes.container}>
      <Grid item xs={12}>
        <InputV2
          errors={{}}
          forceValue={css ?? ''}
          name="css"
          label="کد css"
          register={{}}
          onChangeValue={(e) => setCss(e?.target?.value)}
          fullWidth
          multiline
          dir="ltr"
          mainStyle={{ margin: 0, width: '100%' }}
          inputProps={{ style: { marginBottom: 0, minHeight: 200 } }}
        />
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: theme.spacing(2),
  },
  container: {
    maxWidth: '450px',
  },
  formControl: {
    width: '100%',
  },
  button: {
    minWidth: '135px',
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  buttonWrapper: {
    // textAlign: "right",
  },
  textArea: {
    width: '100%',
    textAlign: 'right',
    direction: 'rtl',
    padding: theme.spacing(2),
  },
  label: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#546e7a',
    marginBottom: 10,
    '&.MuiInputLabel': {
      '&-shrink': {
        transform: 'translate(0, 1.5px) scale(1)',
      },
    },
  },
  asterisk: {
    color: '#ef5350',
  },
  keyGenLine: {
    background: '#eceff1',
    border: 'solid 1px #cfd8dc',
    padding: theme.spacing(1),
    boxSizing: 'border-box',
    marginInlineStart: theme.spacing(2.5),
    marginInlineEnd: theme.spacing(1.5),
    borderRadius: 4,
  },
  keyGenLineTitle: {
    fontSize: 14,
  },
  keyGenLineSubTitle: {
    fontSize: 12,
    color: '#5e7986',
    fontWeight: '300',
    margin: 0,
  },
}));
export default CssBox;
